import type { CompanyEditFormSchemaType } from "@/pages/company-edit/model/schema";
import type { CompanyEditPageProps } from "@/pages/company-edit/model/types";
import { CompanyEditForm } from "@/pages/company-edit/ui/company-edit-form";
import { ConfirmDeleteCompanyDialog } from "@/pages/company-edit/ui/confirm-delete-company-dialog";
import { ScrollToTop } from "@/shared/lib/ScrollToTop";
import { OfferCargoSubscriptionManagement } from "@/widgets/offer-cargo-subscription-management";
import { Stack, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";

type Props = CompanyEditPageProps;

export const CompanyEditPageUi = (props: Props) => {
  const {
    company,
    isXmileSystemAdmin,
    onSubmit,
    onDelete,
    isConfirmDeleteCompanyDialogOpen,
    setIsConfirmDeleteCompanyDialogOpen,
  } = props;

  const initialValues: CompanyEditFormSchemaType | undefined = useMemo(() => {
    if (!company.data) {
      return undefined;
    }

    return {
      companyName: company.data.name ?? "",
      zipCode: company.data.zipCode ?? "",
      address: company.data.address ?? "",
      phoneNumber: company.data.phoneNumber ?? "",
      faxNumber: company.data.faxNumber ?? "",
      email: company.data.email ?? "",
      category: company.data.category?.[0] ?? "shipper",
    };
  }, [company]);

  const onConfirmDeleteCompany = useCallback(() => {
    setIsConfirmDeleteCompanyDialogOpen(true);
  }, [setIsConfirmDeleteCompanyDialogOpen]);

  return (
    <Stack px={{ xs: 2, sm: 4 }} pb={2} spacing={{ xs: 2, sm: 4 }}>
      {/* ヘッダー */}
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <ScrollToTop />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          会社編集
        </Typography>
      </Stack>

      {initialValues && (
        <CompanyEditForm
          initialValues={initialValues}
          onSubmit={onSubmit}
          // XMileシステム管理者以外は企業名を変更できない
          disableCompanyName={!isXmileSystemAdmin}
          // XMileシステム管理者以外は企業種別を隠す
          hideCompanyCategories={!isXmileSystemAdmin}
          // XMileシステム管理者以外は削除ボタンを非表示
          hideDeleteButton={!isXmileSystemAdmin}
          onDelete={onConfirmDeleteCompany}
        />
      )}

      {/* 荷物通知購読管理 */}
      {company.data?.category?.[0] === "carrier" && isXmileSystemAdmin && (
        <OfferCargoSubscriptionManagement companyId={company.data.id} />
      )}

      <ConfirmDeleteCompanyDialog
        open={isConfirmDeleteCompanyDialogOpen}
        onClose={() => setIsConfirmDeleteCompanyDialogOpen(false)}
        onDelete={onDelete}
      />
    </Stack>
  );
};
